module.exports = __webpack_public_path__ + "assets/e981b969eb43d2d960647ec6ac4eb5e7.svg";